// extracted by mini-css-extract-plugin
export default {"captchaWrapper":"NECaptchaComponent_captchaWrapper__cqWOv","backdrop":"NECaptchaComponent_backdrop__K1nq+"};